<template>
  <div id="pickSubjectVue" v-if="isSubjectViewActiveLocal">
    <div v-if="!isTeacher && isStudent && isOverrideModeActive" class="limit-width_fixed-scalable mb-3" style="text-align: left;">
      <div style="text-align: center;">
        <img style="width: 100%;max-width: 550px;max-height: 180px;object-fit: contain;" :src="siteLogoUrl"/>
      </div>
      <span class="mt-3" style="display: inline-flex">
        <img id="profileimg" :src="profilePic" style="width: 25%; height: auto;">
        <div>
          <p style="font-size: 16pt;color:white;" class="ml-4 mt-3">Hi {{ user_displayName.split(' ')[0] }},</p>
          <p style="font-size: 11pt;color:white;" class="ml-4">Welcome back!</p>
        </div>
      </span>
    </div>

    <div v-if="isOverrideModeActive || !isStudent" class="vx-row limit-width_fixed-scalable mb-6">
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>

      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card class="glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickLanguage">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedLanguage }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickGrade">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedGrade.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>


    <div v-if="isStudent" >
      <div class="vx-row mx-auto">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
          <div v-if="!isOverrideModeActive && isStudent" class="limit-width_fixed-scalable mb-3" style="text-align: left;">
            <div style="text-align: center;">
              <img style="width: 100%;max-width: 550px;max-height: 180px;object-fit: contain;" :src="siteLogoUrl" />
            </div>
            <span class="mt-3 p-3 w-full" :style="{ 'border': activeSubscription.id && isUserPremium && isDigiCampus ? '3px solid goldenrod' : activeSubscription.id ? '3px solid white' : 'none' }" style="display: inline-flex; border-radius: 19px;">
              <div class="vx-row w-full">
                <div class="vx-col xl:w-2/3 lg:w-2/3 md:w-2/3 sm:w-full sm:mb-3 xs:mb-3 flex">
                  <div style="position: relative; left: 0; top: 0;" class="ml-2">
                    <img v-show="isUserPremium && isDigiCampus" class="footer-social crown-position" src="@/assets/images/royal-crown-with-three-picks-svgrepo-Gold.png" height="48" />
                    <img id="profileimg" :src="profilePic">
                  </div>
                  <div>
                    <p style="font-size: 16pt;color:white;" class="ml-4 mt-3">Hi {{ user_displayName.split(' ')[0] }},</p>
                    <p style="font-size: 11pt;color:white;" class="ml-4">Welcome back!</p>
                    <div v-if="$getSiteId() != $getSiteIdWithContent()">
                      <p v-if="!isOverrideModeActive" style="font-size: 11pt;font-weight: 500;" class="ml-4 text__school-tertiary-color underline__hover-only" @click="studentOverrideMode"><small><strong>Choose another Language & Grade</strong></small></p>
                    </div>
                  </div>
                </div>
                <div v-if="activeSubscription.id && isDigiCampus" class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/3 sm:w-full align-self-center">
                  <p style="font-size: 11pt;color:white;" class="ml-4"><strong>{{activeSubscription.name}} Subscription</strong></p>
                  <p v-if="activeSubscription.timeRemaining && Math.trunc(activeSubscription.timeRemaining,0) > 1" style="font-size: 11pt;color:white;" class="ml-4"><strong>{{Math.trunc(activeSubscription.timeRemaining,0)}}</strong> days remaining!</p>
                  <p v-else style="font-size: 11pt;color:white;" class="ml-4"><strong>{{Math.trunc(activeSubscription.timeRemaining,0)}}</strong> day remaining!</p>
                </div>
              </div>
            </span>
          </div>
          <div v-if="isDigiCampus" class="limit-width_fixed-scalable mb-3" style="text-align: left;">
            <div class="vx-row mt-2" style="align-items: center;">
              <!--<div id="shop-container" class="vx-col" :class="[{ 'xl:w-1/2 lg:w-1/2 md:w-full sm:w-full w-full xl:mb-0 lg:mb-0 md:mb-3 sm:mb-3 xs:mb-3': activeSubscription.id }, { 'w-full centereverything': !activeSubscription.id }]">
                <vs-button id="shop-courses-btn" class="school-primary_gradient" icon-pack="feather" icon="icon-shopping-bag" @click="goBackToHome">Shop for more courses</vs-button>
              </div>-->
              <div id="shop-container" class="vx-col" :class="[{ 'xl:w-1/2 lg:w-1/2 md:w-full sm:w-full w-full xl:mb-0 lg:mb-0 md:mb-3 sm:mb-3 xs:mb-3': activeSubscription.id }, { 'w-full centereverything': !activeSubscription.id }]">
                <vs-button id="shop-courses-btn" class="school-primary_gradient" icon-pack="feather" icon="icon-home" @click="goBackToHome">Home</vs-button>
              </div>
              <div v-if="activeSubscription.id && isUserPremium" id="renew-container" class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full w-full" style="text-align: -webkit-right;">
                <vs-button id="renew-btn" class="school-primary_gradient" icon-pack="feather" icon="icon-refresh-ccw" @click="goToSubscriptionsPage">Renew now</vs-button>
              </div>
              <div v-else-if="activeSubscription.id && !isUserPremium" id="renew-container" class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full w-full" style="text-align: -webkit-right;">
                <vs-button id="upgrade-btn" class="school-primary_gradient" icon-pack="feather" icon="icon-arrow-up-circle" @click="goToSubscriptionsPage">Upgrade now</vs-button>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full" style="margin: 0 auto ; width: 100%">
          <div class="w-full">
            <ul>
                <div v-if="isStudent" class="swiper-container mb-5">
                  <div class="swiper-inner">
                    <swiper :options="swiperOption">
                      <swiper-slide v-for="(notification, index) in notifications" :key="index">
                        <div class="vx-row ml-2 mr-8">
                          <div class="vx-col w-1/6" style="align-self: center;">
                            <feather-icon icon="BellIcon" width="30" height="30" svgClasses="h-4 w-4" class="mr-3 notification-bell-icon" style="align-self: center;" />
                          </div>
                          <div class="vx-col w-5/6">
                            <span style="display: flex;align-items: baseline;">
                              <p style="font-size: 24pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ notification.title }}</strong></p>
                            </span>
                            <p class="mt-2" style="font-size: 11pt;text-align: left;line-height: 1;font-style: italic;">"{{ notification.message }}"</p>
                            <vs-divider />
                            <p v-if="notification.subjectId" class="mb-2" style="font-size: 18pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ notification.subject }}</strong></p>
                            <p v-else-if="notification.classroom && notification.classroom.id" class="mb-2" style="font-size: 16pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><small>Class:&nbsp;</small><strong>{{ notification.classroom.name }}</strong></p>
                            <span style="display: flex;align-items: baseline;">
                              <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" class="mr-3 teacher-clock-icon_smaller" style="align-self: center;" />
                              <p style="font-size:12pt;">{{ formatNotificationDate(notification.startDate) }} - {{ formatNotificationDate(notification.endDate) }}</p>
                            </span>
                          </div>
                        </div>
                      </swiper-slide>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev"></div>
                      <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                  </div>
                </div>
              <div class="limit-width_fixed-scalable">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div id="dashboard-search-container" class="w-full mb-base">
                      <div class="inline-flex w-full p-1">
                        <feather-icon icon="ArrowRightCircleIcon" width="20" height="20" svgClasses="h-4 w-4" />
                        <input type="text" class="form-control" @keyup.enter="goToSearchPage" placeholder="Search Modules or Topics..." v-model="query">
                        <feather-icon icon="SearchIcon" width="20" height="20" svgClasses="h-4 w-4" style="cursor: pointer;" @click="goToSearchPage" />
                      </div>
                    </div>
                  </div>
                </div>
                  <vx-card v-if="isStudent && virtualClassroom()" class="glow-effect_dark card__no-padding limit-height_fixed float-left mr-3 bg-color mb-3 spaceing">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="PieChartIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        ref="myRosterBtn"
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="viewRoster">
                        View My Roster
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
              </div>

              <div class="limit-width_fixed-scalable">
                  <vx-card v-if="!isOverrideModeActive && isStudent" class="glow-effect_dark card__no-padding limit-height_fixed float-left bg-color mb-3 spaceing">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="EyeIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        :disabled="cannotContinue"
                        ref="continueWatchingBtn"
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="continueWatching">
                        Continue Watching {{ lastTopicData ? '| ' + lastTopicData.selectedData.selectedTopic.name : '' }}
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
              </div>

              <div v-show="$getSiteId() != 8" class="limit-width_fixed-scalable">
                  <vx-card v-if="isStudent" class="glow-effect_dark card__no-padding limit-height_fixed float-left bg-color mb-3 spaceing">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="GridIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        ref="myLibraryBtn"
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="viewLibrary">
                        Library
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
              </div>

              <div v-show="virtualClassroom()" class="limit-width_fixed-scalable">
                  <vx-card v-if="isStudent" class="glow-effect_dark card__no-padding limit-height_fixed float-left bg-color mb-3 spaceing">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="PocketIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        ref="myClassroomsBtn"
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="viewClassrooms">
                        View Uploaded Tasks and Notifications
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
              </div>

              <div v-show="$getSiteId() != 8" class="limit-width_fixed-scalable">
                  <vx-card v-if="isStudent" class="glow-effect_dark card__no-padding limit-height_fixed float-left bg-color mb-3 spaceing">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg">
                          <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="viewResources">
                        Additional Resources
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isStudent" class="vx-row mx-auto">
      <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full" style="width:100%" :style="$getSiteId() == 21 || ($getSiteId() == $getSiteIdWithContent() && isUserPremium && user_grade <= 9) ? '' : 'margin: 0 auto'">
        <div class="mt-4 w-full">
          <ul style="margin-top: 3px;flex-wrap: wrap;">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 100%">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                      type="filled"
                      color=""
                      style="display: flex; width:100%">
                      
                      Select one of your Subjects
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>
            <div v-if="!($getSiteId() == $getSiteIdWithContent())">
              <li v-for="(_subject, subjIndex) in studentSubjects" :key="subjIndex" class="mb-4">
                <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                  <vx-input-group>
                    <template slot="prepend">
                      <vs-button v-if="_subject.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                      <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                        <img height="25" :src="getIcon(_subject.id)" />
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0"
                      @click="selectSubject(_subject)">
                      {{ _subject.name }}
                    </vs-button>
                    <span v-if="!(activeSubscription.id || $getSiteId() == 21)" id="unstar-subject_btn-container"><feather-icon v-show="!_subject.isClassroomSubject" id="unstar-subject_btn" icon="StarIcon" svg-classes="stroke-current" @click.stop.prevent="unstarSubject(_subject.id)" /></span>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>
            <!-- <div v-else-if="$getSiteId() == 21">
              <li v-for="(_subject, subjIndex) in subjects.filter(function(item){ return !studentSubjects.map(function(ss){ return ss.id }).includes(item.id) })" :key="subjIndex" class="mb-4">
                <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                  <vx-input-group>
                    <template slot="prepend">
                      <vs-button v-if="_subject.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                      <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                        <img height="25" :src="getIcon(_subject.id)" />
                      </div>
                    </template>


                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0"
                      @click="selectSubject(_subject)">
                      {{ _subject.name }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </div> -->
            <div v-else-if="$getSiteId() == $getSiteIdWithContent() && user_grade <= 9">
              <li v-for="(_subject, subjIndex) in subjects.filter(function(item){ return !studentSubjects.map(function(ss){ return ss.id }).includes(item.id) })" :key="subjIndex" class="mb-4">
                <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                  <vx-input-group>
                    <template slot="prepend">
                      <vs-button v-if="_subject.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                      <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                        <img height="25" :src="getIcon(_subject.id)" />
                      </div>
                    </template>


                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0"
                      @click="selectSubject(_subject)">
                      {{ _subject.name }}
                    </vs-button>
                    
                    <span v-if="!activeSubscription.id" id="star-subject_btn-container"><feather-icon id="star-subject_btn" icon="StarIcon" svg-classes="stroke-current" @click.stop.prevent="starSubject(_subject.id)" /></span>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>
            <div v-else-if="$getSiteId() == $getSiteIdWithContent()  ">
              <li v-for="(_subject, subjIndex) in studentSubjects" :key="subjIndex" class="mb-4">
                <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                  <vx-input-group>
                    <template slot="prepend">
                      <vs-button v-if="_subject.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                      <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                        <img height="25" :src="getIcon(_subject.id)" />
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0"
                      @click="selectSubject(_subject)">
                      {{ _subject.name }}
                    </vs-button>
                    <span v-if="!activeSubscription.id" id="unstar-subject_btn-container"><feather-icon v-show="!_subject.isClassroomSubject" id="unstar-subject_btn" icon="StarIcon" svg-classes="stroke-current" @click.stop.prevent="unstarSubject(_subject.id)" /></span>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>
            <p v-show="showNoSubjects" style="color:white;font-weight:500;font-size:16px;padding-top:5px">You don't have any subjects yet...</p>
          </ul>
        </div>
      </div>

      <div  class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full">
        <div class="mt-4 w-full">
          <ul style="margin-top: 3px;flex-wrap: wrap;">
            <div class="limit-width_fixed-scalable pb-2" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 100%">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                      type="filled"
                      color=""
                      style="display: flex; width:100%">
                      
                      Select another Subject
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>

            <div v-if="!activeSubscription.id" class="limit-width_fixed-scalable mb-3" style="text-align: left; border-style: solid;border-radius: 12px;">
              <li>
                <vx-card class="limit-width_fixed-scalable card__no-padding bg-color">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-color" style="border-right-style: solid;">
                        <span><feather-icon class="pt-1" icon="InfoIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align info-header_button bg-color"
                      style="border-radius:0 7px 7px 0;"
                      type="filled"
                      color="">
                      Simply click on the stars below to add subjects to your profile
                    </vs-button>
                    <span id="star-subject_btn--info-container"><feather-icon id="star-subject_btn--info" icon="StarIcon" svg-classes="stroke-current" /></span>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>
            <li v-for="(_subject, subjIndex) in subjects.filter(function(item){ return !studentSubjects.map(function(ss){ return ss.id }).includes(item.id) })" :key="subjIndex" class="mb-4">
              <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                <vx-input-group>
                  <template slot="prepend">
                    <vs-button v-if="_subject.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                    <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                      <img height="25" :src="getIcon(_subject.id)" />
                    </div>
                  </template>

                  <vs-button
                    size="large"
                    class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                    style="border-radius:0 7px 7px 0"
                    @click="selectSubject(_subject)">
                    {{ _subject.name }}
                  </vs-button>
                  
                  <span v-if="!activeSubscription.id" id="star-subject_btn-container"><feather-icon id="star-subject_btn" icon="StarIcon" svg-classes="stroke-current" @click.stop.prevent="starSubject(_subject.id)" /></span>
                </vx-input-group>
              </vx-card>
            </li>
            <p v-show="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">Watch this space! Content coming soon...</p>
          </ul>
        </div>
      </div>
    </div>

    <div v-else class="mt-4 w-full">
      <ul style="margin-top: 3px;flex-wrap: wrap;">
        <div class="limit-width_fixed-scalable" style="text-align: left;">
          <li>
            <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text glow-effect_bg-color__blend bg-color">
                    <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>
                <vs-button
                          :disabled="true"
                          size="large"
                          class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                          type="filled"
                          color="">
                  Select a Subject
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
        <li v-for="(_subject, subjIndex) in subjects" :key="subjIndex" class="mb-4">
          <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <vs-button v-if="_subject.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                  <img height="25" :src="getIcon(_subject.id)" />
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                style="border-radius:0 7px 7px 0"
                @click="selectSubject(_subject)">
                {{ _subject.name }}
              </vs-button>
              <span v-if="subjects.length != 1 && !isStudent" id="manage-topic-fab" class="WTF">
                <div class="fab_inline--button">
                  <div class="float-btn-group">
                    <button
                      class="btn-float btn-triger input-group_prepend-slot-bg"
                      @click="openActions($event)"
                      :id="`subject-${_subject.id}`"

                    >
                      <i
                        class="icon feather icon-more-horizontal text-white"
                      />
                    </button>
                    <div class="btn-list">
                        <a
                          v-show="subjIndex != 0"
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="moveCourseUp(_subject.id,subjIndex)"
                        >
                          <i
                            class="icon feather icon-arrow-up-circle text-white"
                          ></i>
                        </a>
                        <a
                          v-show="false"
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="editTask(_subject)"
                        >
                          <i class="icon feather icon-edit text-white"></i>
                        </a>
                        <a
                            v-show="subjIndex < subjects.length - 1"
                          class="btn-float _subject-purple description glow-effect_dark"
                          @click="moveCourseDown(_subject.id,subjIndex)"
                        >
                          <i
                            class="icon feather icon-arrow-down-circle text-white"
                          ></i>
                        </a>
                        <a
                          v-show="false"

                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="deleteTask(_task)"
                        >
                          <i
                            class="icon feather icon-trash-2 text-danger"
                          ></i>
                        </a>
                    </div>
                  </div>
                </div>
              </span>
            </vx-input-group>
          </vx-card>
        </li>
        <p v-show="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">Watch this space! Content coming soon...</p>
      </ul>
    </div>
    <!-- <vs-divider /> -->
    
  </div>
</template>

<script>
import defaultIcon from '../../assets/subjecticons/default.svg'
import mathsIcon from '../../assets/subjecticons/maths.svg'
import mathsliteracyIcon from '../../assets/subjecticons/maths-literacy.svg'
import afrikaanshomeIcon from '../../assets/subjecticons/afrikaans-home.svg'
import afrikaansfirstIcon from '../../assets/subjecticons/afrikaans-first.svg'
import englishhomeIcon from '../../assets/subjecticons/english-home.svg'
import englishfirstIcon from '../../assets/subjecticons/english-first.svg'
import lifeskillsIcon from '../../assets/subjecticons/life-skills.svg'
import lifesciencesIcon from '../../assets/subjecticons/life-sciences.svg'
import socialscienceIcon from '../../assets/subjecticons/social-science.svg'
import lifeorientationIcon from '../../assets/subjecticons/life-orientation.svg'
import naturalscienceandtechnologyIcon from '../../assets/subjecticons/natural-science-and-technology.svg'
import geographyIcon from '../../assets/subjecticons/geography.svg'
import economicsIcon from '../../assets/subjecticons/economics.svg'
import accountingIcon from '../../assets/subjecticons/accounting.svg'
import tourismIcon from '../../assets/subjecticons/tourism.svg'
import naturalscienceIcon from '../../assets/subjecticons/natural-science.svg'
import historyIcon from '../../assets/subjecticons/history.svg'
import egdIcon from '../../assets/subjecticons/eng-graphics-and-design.svg'
import technologyIcon from '../../assets/subjecticons/technology.svg'
import computerapptechnologyIcon from '../../assets/subjecticons/computer-app-technology.svg'
import itIcon from '../../assets/subjecticons/it.svg'
import electricaltechnologyIcon from '../../assets/subjecticons/electrical-technology.svg'
import mechanicaltechnologyIcon from '../../assets/subjecticons/mechanical-technology.svg'
import civiltechnologyIcon from '../../assets/subjecticons/civil-technology.svg'
import businessstudiesIcon from '../../assets/subjecticons/business-studies.svg'
import consumerstudiesIcon from '../../assets/subjecticons/consumer-studies.svg'
import physicalscienceIcon from '../../assets/subjecticons/physical-science.svg'
import chessIcon from '../../assets/subjecticons/chess.svg'
import creativeartsIcon from '../../assets/subjecticons/creative-arts.svg'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import moment from 'moment'
export default {
  components: {
    swiper,
    swiperSlide,
    moment
  },
  data() {
    return {
      math: [38,39,47,51,54,55,56,57,58,59,89,130,139,141,143,145,148,150,176,189,196,225,236,248,259,261,341,361,367,380,388,389,398,400,408,412,417],
      mathLit: [44,115,124,266,268,269,349,368,393],
      afrHuis: [40,41,60,61,62,63,165,201,202,204,250,252,258],
      afrEat: [46,64,78,80,91,200,206,211,213,238,239,240,676],
      engHome: [52,90,92,98,100,131,215,228,232,235,244,245,246],
      engFal: [53,81,82,83,132,163,192,193,195,241,242,243,332,343,370,390,399,518],
      lifeSkill: [45,49,79,88,103,104,109,110,197,198,334,409,410,414,421],
      lifeScience: [48,106,113,310,311,313,359,371,395],
      socScience: [71,72,116,117,118,119,126,184,186,187,205,207],
      lifeOrient: [84,85,86,154,155,157,249,251,253,255,256,257,527],
      natSciTech: [42,50,74,77,185,191],
      geography: [94,95,96,97,99,105,344,378,391],
      econManSci: [120,122,125,175,177,178],
      economics: [128,133,135,229,230,231,354,376,394],
      accounting: [136,138,146,210,212,216,345,373,392],
      tourism: [156,158,160,180,199,348,372,403,511,512,513],
      natScience: [111,112,114,181,182,183],
      history: [140,142,144,147,149,151,342,374,404,429],
      egd: [127,129,134,260,263,267],
      tech: [171,172,174,188,190,194],
      compAppTech: [137,152,161,214,220,223],
      it: [164,167,179,270,271,272],
      elecTech: [291,292,293],
      mechTech: [315,316,317],
      civilTech: [318,319,320],
      busStudy: [153,159,166,219,221,222,346,365,405,495,506,507],
      consStud: [168,170,173,233,234,237],
      physScience: [208,209,218,224,226,227,347,369,397],
      chess: [335,336,337,338],
      agriSci: [350,366,402],
      arts: [362],
      isixhosa: [333,352,387,401],
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          enabled: true,
          delay: 5000,
          disableOnInteraction: false
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      query: "",
      elementOpen:false,
      selectedElement:"",
      
    };
  },
  props: {
    isUserPremium: {
      type: Boolean,
      required: false
    },
    activeSubscription: {
      type: Object,
      required: false
    },
    isSubjectViewActive: {
      type: Boolean,
      required: true,
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    isTeacher: {
      type: Boolean,
      required: false
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      type: Object,
      required: false
    },
    subjects: {
      type: Array,
      required: true
    },
    cannotContinue: {
      type: Boolean,
      required: false
    },
    lastTopicData: {
      type: Object,
      required: false
    },
    showComingSoon: {
      required: false
    },
    isOverrideModeActive: {
      required: false
    },
    showNoSubjects: {
      required: false
    },
    studentSubjects: {
      type: Array,
      required: true
    },
    notifications: {
      type: Array
    },
    studentGradeId: {
      required: false
    }
  },
  computed: {
    isDigiCampus: {
      get() {
        if(localStorage.getItem('userSiteInfo') && JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          return JSON.parse(localStorage.getItem('userSiteInfo'))[0].siteId == this.$getSiteIdWithContent();
        else 
          return JSON.parse(localStorage.getItem('userSiteInfo')).siteId == this.$getSiteIdWithContent();
      }
    },
    isSubjectViewActiveLocal: {
      get() {
        return this.isSubjectViewActive;
      }
    },
    user_grade: {
      get() {
        return JSON.parse(localStorage.getItem('userGrade'));
      }
    },
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null
        ? JSON.parse(localStorage.getItem("userInfo")).displayName.split("(")[0]
        : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    profilePic() {
      return localStorage.getItem("pictureUrl") == null ||
        localStorage.getItem("pictureUrl") == "null" ||
        localStorage.getItem("pictureUrl") == "" ||
        localStorage.getItem("pictureUrl") == "undefined"
        ? "https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png"
        : localStorage.getItem("pictureUrl");
    },
    siteLogoUrl: function() {
      if (this.$store.state.schoolTheme == "digi") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/logo-if-on-white.png";
      }
      else if (this.$store.state.schoolTheme == "istudy") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/i-study-logo.png";
      }
      else if (this.$store.state.schoolTheme == "wced") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/wced-logo.gif";
      }
      else if (this.$store.state.schoolTheme == "swales") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/swales-logo.png";
      }
      else if (this.$store.state.schoolTheme == "ligbron") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/ligbron-logo.png";
      }
      else if (this.$store.state.schoolTheme == "moetapele") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/moetapele-logo.png';
      }
      else if (this.$store.state.schoolTheme == "spesres") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/spesres-logo-new.png';
      }
      else if (this.$store.state.schoolTheme == "bdce") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/bdce-logo.png';
      }
      else if (this.$store.state.schoolTheme == "digicentral") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/digicentral-logo.png';
      }
      else if (this.$store.state.schoolTheme == "shayela") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/shayela-logo.png';
      }
      else if (this.$store.state.schoolTheme == "sonke") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/sonke-logo.png';
      }
      else if (this.$store.state.schoolTheme == "route") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/route-logo.png';
      }
      else if (this.$store.state.schoolTheme == "e-ligbron") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/ligbron-e-logo.png';
      }
      else if (this.$store.state.schoolTheme == "cocacola") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/coca-cola.svg';
      }
      else if (this.$store.state.schoolTheme == "custom") {
        if(localStorage.getItem('userSiteInfo') != ""){
          if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
            return JSON.parse(localStorage.getItem('userSiteInfo'))[0].logoUrl;
          else 
            return JSON.parse(localStorage.getItem('userSiteInfo')).logoUrl;
        }
        else
          return "";
      }
    },
  },
  methods: {
    closebtnGroups(){
      var self = this;
      var openBtnGroups = [];
      openBtnGroups = document.getElementsByClassName('float-btn-group open');
      openBtnGroups.forEach(element => {
        element.classList.remove("open");
      });
    },
    openActions(e) {
      this.closebtnGroups();
      this.fabElement= e.target.closest(".float-btn-group");

      if(!this.selectedElement || this.selectedElement != this.fabElement.firstChild.id){
        this.fabElement.classList.add('open')
        this.selectedElement = this.fabElement.firstChild.id;
      }
      else if(this.selectedElement == this.fabElement.firstChild.id){
        this.fabElement.classList.remove('open');
        this.selectedElement = "";
      }
      
    },
    goBackToHome() {
      window.open('../home', '_self');
    },
    goToSubscriptionsPage() {
      window.open('../subscriptions?ref=subscribe', '_self');
    },
    studentOverrideMode() {
      // localStorage.setItem("studentOverrideMode", "1");
      this.$emit("studentOverrideMode");
    },
    selectSubject(subject) {
      var self = this;
      var icon = self.getIcon(subject.id);
      self.$emit("subjectSelected", subject, icon);
    },
    viewRoster() {
      this.$emit("viewRoster");
    },
    continueWatching() {
      var self = this;
      var task = self.lastTopicData.standaloneContentDto.tasks[self.lastTopicData.index];

      if (task.video) {
        self.$router.push({
          name: "VideoViewer",
          params: {
            index: self.lastTopicData.index,
            standaloneContent: self.lastTopicData.standaloneContentDto,
            selectedData: self.lastTopicData.selectedData
          }
        });
      }
    },
    viewLibrary() {
      this.$emit("viewLibrary");
    },
    viewClassrooms() {
      this.$emit("viewClassrooms");
    },
    virtualClassroom(){
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        return JSON.parse(localStorage.getItem('userSiteInfo'))[0].virtualClassroom;
      else 
        return JSON.parse(localStorage.getItem('userSiteInfo')).virtualClassroom;
    },
    viewResources() {
      this.$emit("viewResources");
    },
    getIcon(id) {
      var self = this;
      if (self.math.includes(id))
        return mathsIcon;
      else if (self.mathLit.includes(id))
        return mathsliteracyIcon;
      else if (self.afrHuis.includes(id))
        return afrikaanshomeIcon;
      else if (self.afrEat.includes(id))
        return afrikaansfirstIcon;
      else if (self.engHome.includes(id))
        return englishhomeIcon;
      else if (self.engFal.includes(id))
        return englishfirstIcon;
      else if (self.lifeSkill.includes(id))
        return lifeskillsIcon;
      else if (self.lifeScience.includes(id))
        return lifesciencesIcon;
      else if (self.socScience.includes(id))
        return socialscienceIcon;
      else if (self.lifeOrient.includes(id))
        return lifeorientationIcon;
      else if (self.natSciTech.includes(id))
        return naturalscienceandtechnologyIcon;
      else if (self.geography.includes(id))
        return geographyIcon;
      else if (self.economics.includes(id))
        return economicsIcon;
      else if (self.accounting.includes(id))
        return accountingIcon;
      else if (self.tourism.includes(id))
        return tourismIcon;
      else if (self.natScience.includes(id))
        return naturalscienceIcon;
      else if (self.history.includes(id))
        return historyIcon;
      else if (self.egd.includes(id))
        return egdIcon;
      else if (self.tech.includes(id))
        return technologyIcon;
      else if (self.compAppTech.includes(id))
        return computerapptechnologyIcon;
      else if (self.it.includes(id))
        return itIcon;
      else if (self.elecTech.includes(id))
        return electricaltechnologyIcon;
      else if (self.mechTech.includes(id))
        return mechanicaltechnologyIcon;
      else if (self.civilTech.includes(id))
        return civiltechnologyIcon;
      else if (self.busStudy.includes(id))
        return businessstudiesIcon;
      else if (self.consStud.includes(id))
        return consumerstudiesIcon;
      else if (self.physScience.includes(id))
        return physicalscienceIcon;
      else if (self.chess.includes(id))
        return chessIcon;
      else if (self.arts.includes(id))
        return creativeartsIcon;
      else
        return defaultIcon;
    },
    backToPickLanguage() {
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.$emit("backToPickGrade");
    },
    starSubject(subjectId) {
      this.$emit("starSubject", subjectId);
    },
    unstarSubject(subjectId) {
      this.$emit("unstarSubject", subjectId);
    },
    formatNotificationDate(date) {
      var self = this;
      var dateString = new Date(Date.parse(date));

      var hour = dateString.getHours();
      var minutes = dateString.getMinutes();

      var result = moment(dateString.toISOString()).format("DD MMMM YYYY HH:mm");
      return result;
    },
    goToSearchPage() {
      if (this.query)
        this.$router.push({ name: 'Search', query: { gradeId: this.studentGradeId ? this.studentGradeId : this.selectedGrade.id, query: this.query } });
    },
    moveCourseUp(courseId, index){
      var self = this;
      self.indexButtonClicked = true;
      var swapcourseIndex = self.subjects[index].id;
      if(!swapcourseIndex){
        self.indexButtonClicked = false;
        return
      }
      var swapcourseId = self.subjects[index - 1].id;
      var onSuccess = response =>{
        self.closebtnGroups();
        this.selectedElement = "";
        self.$emit("moveCourseUp",index);
      }
      var onFinally = response =>{
        self.indexButtonClicked = false;
        self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Order change saved`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
      }
      self.$ajaxGet(self, `Course/MoveIndexCourse?courseId=${courseId}&swapCourseId=${swapcourseId}`  , onSuccess, onFinally);
    },
    moveCourseDown(courseId,index){
      var self = this;
      self.indexButtonClicked = true;
      var swapcourseIndex = self.subjects[index].id;
      if(!swapcourseIndex){
        self.indexButtonClicked = false;
        return
      }
      var swapcourseId = self.subjects[index + 1].id;
      var onSuccess = response =>{
        self.closebtnGroups();
        this.selectedElement = "";
        self.$emit("moveCourseDown",index);
      }
      var onFinally = response =>{
        self.indexButtonClicked = false;
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order change saved`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      }
      self.$ajaxGet(self, `Course/MoveIndexCourse?courseId=${swapcourseId}&swapCourseId=${courseId}`  , onSuccess, onFinally);
    },
  }
};
</script>
<style lang="scss">
.swiper-inner {
    overflow: hidden;
    // padding: 15px;
    widows: 100% !important;
}

.swiper-container {
    width: 100% !important;
}

.swiper-slide {
    background-position: center;
    background-size: cover;
}
@media screen and (max-width: 500px) {
  .limit-width_fixed-scalable{
    min-width: unset !important;
  }
  .router-view{
    padding-inline: unset !important;
  }

}

@media screen and (max-width: 340px){
  .vs-button.large{
    padding: 1rem !important;
  }
}

#renew-btn {
  border-radius: 30px !important;
  border: 3px solid rgba(var(--vs-primary),1) !important;

  &.vs-button {
    .vs-button-text {
      font-size: 1.2rem !important;
    }
    .vs-icon {
      margin-right: 10px !important;
      font-size: 1.6rem !important;
    }
  }
}

#upgrade-btn {
  border-radius: 30px !important;
  border: 3px solid goldenrod !important;

  &.vs-button {
    .vs-button-text {
      font-size: 1.2rem !important;
    }
  .vs-icon {
      margin-right: 10px !important;
      font-size: 1.6rem !important;
    }
  }
}

.crown-position
  {
    transform: rotate(340deg);
    position: absolute;
    top: -11px;
    left: -15px;
  }

@media (max-width: 500px) {
  .xs\:mb-3 {
    margin-bottom: 0.75rem !important;
  }
}

@media (max-width: 920px) {
  #shop-container, #renew-container {
    text-align: -webkit-center !important;
    text-align: -moz-center;
  }
}
#pickSubjectVue{
  .spaceing{
    height: fit-content !important;
    max-height: fit-content !important;
  }
}
</style>
